<template>
  <div class="table-responsive">
    <table>
      <thead>
        <tr>
          <th>Nombre de campo</th>
          <th>Descripción</th>
          <th v-show="enviable">SRI</th>
          <th class="ta-right">
            <button
              :disabled="disabled"
              @click="agregarInformacionAdicional"
              class="btn-success"
              type="button"
            >
              <i class="fa fa-plus"></i>
            </button>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, index) in modelValue" :key="index">
          <td valign="top" :tooltip="row.nombre_campo!==''?row.nombre_campo:'Digite...'">
            <input-field
              :disabled="disabled || esFechaVencimiento(row) || esRucProveedor(row)"
              @input="$emit('input', modelValue)"
              placeholder="Campo"
              :id="'campo' + index"
              v-model="row.nombre_campo"
            >
              <span
                v-if="erroresFormulario.hasOwnProperty('informacionAdicional.' + index + '.nombre_campo')"
                class="helper-text text-danger"
                slot="helper"
              >
                <strong>{{ erroresFormulario['informacionAdicional.' + index + '.nombre_campo'][0] }}</strong>
              </span>
            </input-field>
          </td>
          <td valign="top" :tooltip="row.valor_campo!==''?row.valor_campo:'Digite...'">
            <textarea-field
              placeholder="Escriba una observación..."
              @input="$emit('input', modelValue)"
              :disabled="disabled || esFechaVencimiento(row) || esRucProveedor(row)"
              v-model="row.valor_campo"
              :id="'valorCampo' + index"
            >
              <span
                v-if="erroresFormulario.hasOwnProperty('informacionAdicional.' + index + '.valor_campo')"
                class="helper-text text-danger"
                slot="helper"
              >
                <strong>{{ erroresFormulario['informacionAdicional.' + index + '.valor_campo'][0] }}</strong>
              </span>
            </textarea-field>
          </td>
          <td v-show="enviable">
            <label :for="'sriEnviable' + index">
              <input
                :disabled="esRucProveedor(row)"
                v-model="modelValue[index].enviar_sri"
                type="checkbox"
                :id="'sriEnviable' + index"
              />
              <span>&nbsp;</span>
            </label>
            <!-- <p>
            </p> -->
          </td>
          <td>
            <button
              :disabled="disabled || esRucProveedor(row)"
              @click="eliminarInformacionAdicional(index)"
              class="btn-danger btn--text-outline"
              type="button"
            >
              <i class="fa fa-trash-o"></i>
            </button>
          </td>
        </tr>
        <tr v-show="modelValue.length === 0">
          <td :colspan="enviable?4:3">
            <strong>No se ha agregado información adicional.</strong>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default: function() {
        return [];
      },
      required: false
    },
    errores: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    enviable: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function() {
    return {
      modelValue: this.value,
      erroresFormulario: this.errores
    };
  },
  methods: {
    esRucProveedor: function(row){
      return row.nombre_campo === "RUC Proveedor";
    },
    esFechaVencimiento: function(row) {
      return row.nombre_campo === "Fecha de vencimiento";
    },
    agregarInformacionAdicional: function() {
      this.modelValue.push({
        nombre_campo: "",
        valor_campo: "",
        enviar_sri: true
      });
      this.$emit("input", this.modelValue);
    },
    eliminarInformacionAdicional: function(index) {
      let that = this;
      swal({
        title: "¿Desear eliminar esta información adicional?",
        text: "Esta acción requiere de confirmación.",
        type: "question",
        showCancelButton: true,
        confirmButtonText: "Eliminar",
        cancelButtonText: "No"
      }).then(result => {
        if (result.value) {
          that.modelValue.splice(index, 1);
          that.$emit("input", that.modelValue);
        }
      });
    }
  },
  watch: {
    value: function(value) {
      this.modelValue = value;
    },
    errores: function(value) {
      this.erroresFormulario = value;
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/comprobantes/TablaInformacionAdicional.vue